let AppConfig = {
    // "app_name" : "Sun Resorts",
    // "image_base_path" : "assets/images/application/sun-resorts",
    "app_name" : "Heritage",
    "image_base_path" : "assets/images/application/heritage",
}

export {AppConfig}